import { render, staticRenderFns } from "./addCardDialog.vue?vue&type=template&id=35ffb8df&scoped=true"
import script from "./addCardDialog.vue?vue&type=script&lang=js"
export * from "./addCardDialog.vue?vue&type=script&lang=js"
import style1 from "./addCardDialog.vue?vue&type=style&index=1&id=35ffb8df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ffb8df",
  null
  
)

export default component.exports